"use client";
import React from "react";
// Assuming you have icons imported (replace with your actual icon library or SVG)
// For demo, using lucide-react icons as placeholders - install lucide-react if needed
import {
  ShieldCheck,
  Truck,
  RefreshCw,
  Star,
  Award,
  Headphones,
  ThumbsUp,
  Package,
  Users,
} from "lucide-react";

const Features = ({ product }) => {
  console.log("Product in Features:", product);
  return (
    <div className="w-full mx-auto px-4 py-2 md:py-3 ">
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-3">
        {/* Printshoppy Promise - Full width on mobile, 1/4 on lg */}
        <div className="col-span-1 lg:col-span-1 bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center h-full">
          <ShieldCheck className="w-12 h-12 text-purple-600 mb-4" />
          <h3 className="text-2xl md:text-3xl font-bold text-purple-600 mb-2">
            Manaprints

            Promise
          </h3>
          <p className="text-gray-500 text-sm md:text-base mt-2">
            We stand behind every product we make. If our products fail to live up to your standards, you can return them for a replacement or refund.
          </p>
          <p className="mt-3 font-bold text-gray-900 text-sm md:text-base">
            - No Questions Asked
          </p>
        </div>



        {/* Free Shipping + Easy Returns - grouped in one column on larger screens */}
        <div className="col-span-1 lg:col-span-1 grid grid-cols-1 sm:grid-cols-3 gap-3">
          {/* Free Shipping */}
          <div className="bg-white rounded-2xl shadow-lg p-3 flex flex-col items-center text-center h-full">
            <Truck className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-2xl md:text-3xl font-bold text-blue-600 mb-2">
              RELIABLE
              <br />
              DELIVERY
            </h3>
            <p className="text-gray-500 text-sm md:text-base mt-2">
              Consistent and dependable from dispatch to doorstep.
            </p>
          </div>

          {/* Return Policy */}
          <div className="bg-white rounded-2xl shadow-lg p-3 flex flex-col items-center text-center h-full">
            <RefreshCw className="w-12 h-12 text-yellow-600 mb-4" />
            <h3 className="text-2xl md:text-3xl font-bold text-yellow-600 mb-2">
              RETURN
              <br />
              POLICY
            </h3>
            <p className="text-gray-500 text-sm md:text-base mt-2">
              {product?.product_policy || "We provide hassle free returns & refunds."}
            </p>
          </div>
          {/* Return Support */}
          <div className="bg-white rounded-2xl shadow-lg p-3 flex flex-col items-center text-center h-full">
            <Headphones className="w-12 h-12 text-indigo-600 mb-4" />
          <h3 className="text-2xl md:text-3xl font-bold text-indigo-600 mb-2">
            RETURN
            <br />
            SUPPORT
          </h3>
          <p className="text-gray-500 text-sm md:text-base mt-2">
            We're here to help with your returns, every step of the way.
          </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
